import { supabase } from '@/lib/supabase'

// Shared client for the miles-portal edge function's `status` action, used
// by the Status and LimoAnywhere cards (same React Query key, one request).

export interface LaPluginStatus {
  connected: boolean
  lastSeenAt: string
  pluginVersion: string
  host: string
  platform: string
}

export interface OttoStatus {
  locationId: string
  appInstalled: boolean
  /** The viewer's own Claude grant (false in the admin view — the admin has none here). */
  claudeConnected: boolean
  /** Anyone on this location has a live Claude grant — what the badge shows. */
  anyoneConnected?: boolean
  /** Freshest Cowork plugin heartbeat tagged with this location; null when none. */
  laPlugin?: LaPluginStatus | null
  lastActivityAt: string | null
  /** Where this location's users must point Claude; null until the app is installed. */
  connectorUrl?: string | null
  servedHere?: boolean
}

export async function callOttoPortal(body: Record<string, unknown>): Promise<OttoStatus> {
  const { data, error } = await supabase.functions.invoke('miles-portal', { body })
  if (error) {
    const status = (error as { context?: { status?: number } }).context?.status
    throw new Error(status === 404 ? 'no_location_mapping' : 'unavailable')
  }
  return data as OttoStatus
}

export function relativeTime(iso: string): string {
  const minutes = (Date.now() - new Date(iso).getTime()) / 60000
  if (minutes < 2) return 'just now'
  if (minutes < 60) return `${Math.round(minutes)} minutes ago`
  if (minutes < 60 * 48) return `${Math.round(minutes / 60)} hours ago`
  return `${Math.round(minutes / 60 / 24)} days ago`
}
